import api from './api'

/**
 * Serviço de Notificações
 */
export default {
  /**
   * Listar notificações do usuário
   */
  list(params = {}) {
    return api.get('/api/notifications', { params })
  },

  /**
   * Marcar notificação como lida
   */
  markAsRead(id) {
    return api.put(`/api/notifications/${id}/read`)
  },

  /**
   * Marcar todas como lidas
   * Backend não tem endpoint para marcar todas, então marca individualmente
   */
  async markAllAsRead(notificationIds) {
    const promises = notificationIds.map(id => this.markAsRead(id))
    return Promise.all(promises)
  },

  /**
   * Deletar notificação específica
   */
  delete(id) {
    return api.delete(`/api/notifications/${id}`)
  },

  /**
   * Deletar múltiplas notificações
   */
  deleteBatch(notificationIds) {
    return api.delete('/api/notifications/batch', { data: notificationIds })
  },
}
